import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';

/**
 * AppMenuTile — bouton de menu "app store" : rangée pleine largeur, hauteur fixe,
 * icône carrée + libellé + sous-titre tronqué sur une ligne + chevron. Utilisé partout où
 * l'app propose une liste d'actions/sections (Nutrition, Entraînements, Profil…) pour que
 * TOUS les boutons aient exactement la même taille, quelle que soit la longueur du texte.
 */
export const AppMenuTile = ({ icon: Icon, label, sub, onClick, gradient, testId, badge }) => (
  <motion.button
    whileTap={{ scale: 0.98 }}
    onClick={onClick}
    className="relative w-full flex items-center gap-3.5 overflow-hidden rounded-2xl bg-white/[0.035] backdrop-blur-xl border border-white/10 shadow-[0_0_30px_-12px_rgba(217,70,239,0.25)] hover:border-primary/30 px-4 py-4 text-left transition-colors"
    data-testid={testId}
  >
    <div className={`w-12 h-12 rounded-xl flex items-center justify-center shrink-0 ${gradient}`}>
      <Icon className="w-6 h-6 text-white" />
    </div>
    <div className="min-w-0 flex-1">
      <p className="font-bold text-white text-[15px] truncate" style={{ fontFamily: 'Outfit, sans-serif' }}>{label}</p>
      {sub && <p className="text-xs text-zinc-500 truncate mt-0.5">{sub}</p>}
    </div>
    {badge}
    <ChevronRight className="w-5 h-5 text-zinc-600 shrink-0" />
  </motion.button>
);

export default AppMenuTile;
